import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
export function StoriesSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const impactAreas = [{
    title: 'Education & Youth Empowerment',
    description: 'We believe every child deserves access to quality education. Our scholarship programs and educational support initiatives help underprivileged students pursue their dreams and build better futures.',
    image: 'https://cdn.magicpatterns.com/uploads/tFDLuyek5uaiJaBk7KCJhX/b503129e-f39b-4a87-b053-66ccdd6331b4.jpg',
    tag: 'Education'
  }, {
    title: 'Community Development',
    description: 'Through strategic partnerships and grassroots engagement, we work directly with communities to identify needs and implement sustainable solutions that create lasting change.',
    image: 'https://cdn.magicpatterns.com/uploads/p3pVnsessfovnWYR2yoJzV/f6651de8-d8ff-4bdf-a83b-efe29d494201.jpg',
    tag: 'Community Development'
  }, {
    title: 'Healthcare & Wellness',
    description: 'Access to healthcare is a fundamental right. We support medical outreach programs and health education initiatives to improve the wellbeing of underserved communities across Nigeria.',
    image: 'https://cdn.magicpatterns.com/uploads/6scM7hFcDkDU7XnaRL8N8f/c89f7068-167c-41a3-b616-1bca527b3956.jpg',
    tag: 'Healthcare'
  }];
  const nextStory = () => {
    setActiveIndex(prev => (prev + 1) % impactAreas.length);
  };
  const prevStory = () => {
    setActiveIndex(prev => (prev - 1 + impactAreas.length) % impactAreas.length);
  };
  // Auto-advance
  useEffect(() => {
    const timer = setInterval(nextStory, 6000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-24 bg-charcoal text-white overflow-hidden" data-id="element-378">
      <div className="container mx-auto px-4" data-id="element-379">
        <div className="text-center mb-12" data-id="element-380">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-381">
            Our Impact Areas
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto" data-id="element-382">
            Discover how we're working to transform lives and build stronger
            communities across Nigeria
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-383">
          {/* Image Side */}
          <div className="w-full lg:w-1/2 relative" data-id="element-384">
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-sfrr-pink rounded-full opacity-20 blur-2xl" data-id="element-385"></div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-sfrr-blue rounded-full opacity-20 blur-2xl" data-id="element-386"></div>

            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl" data-id="element-387">
              {impactAreas.map((area, index) => <div key={index} className={`absolute inset-0 w-full h-full transition-all duration-700 ease-in-out ${index === activeIndex ? 'opacity-100 scale-100' : 'opacity-0 scale-105'}`} data-id="element-388">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10" data-id="element-389"></div>
                  <img src={area.image} alt={area.title} className="w-full h-full object-cover" data-id="element-390" />
                </div>)}

              {/* Navigation Buttons Overlay */}
              <div className="absolute bottom-0 right-0 bg-white flex z-20" data-id="element-391">
                <button onClick={prevStory} className="p-4 text-charcoal hover:bg-gray-100 transition-colors border-r border-gray-100" aria-label="Previous area" data-id="element-392">
                  <ChevronLeft size={24} data-id="element-393" />
                </button>
                <button onClick={nextStory} className="p-4 text-charcoal hover:bg-gray-100 transition-colors" aria-label="Next area" data-id="element-394">
                  <ChevronRight size={24} data-id="element-395" />
                </button>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="w-full lg:w-1/2" data-id="element-396">
            <Quote className="text-sfrr-pink w-12 h-12 mb-8 opacity-80" data-id="element-397" />

            <div className="relative min-h-[300px]" data-id="element-398">
              {impactAreas.map((area, index) => <div key={index} className={`absolute top-0 left-0 w-full transition-all duration-700 ${index === activeIndex ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-8 pointer-events-none'}`} data-id="element-399">
                  <span className="inline-block px-3 py-1 rounded-full bg-white/10 text-sm font-medium mb-6 backdrop-blur-sm border border-white/10" data-id="element-400">
                    {area.tag}
                  </span>
                  <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold leading-tight mb-6" data-id="element-401">
                    {area.title}
                  </h3>
                  <p className="text-lg text-gray-300 leading-relaxed" data-id="element-402">
                    {area.description}
                  </p>
                </div>)}
            </div>

            {/* Progress Indicators */}
            <div className="flex gap-2 mt-8" data-id="element-403">
              {impactAreas.map((_, index) => <button key={index} onClick={() => setActiveIndex(index)} className={`h-1 rounded-full transition-all duration-300 ${index === activeIndex ? 'w-8 bg-sfrr-pink' : 'w-2 bg-white/20 hover:bg-white/40'}`} aria-label={`Go to area ${index + 1}`} data-id="element-404" />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}